import React, { memo } from 'react';
import { Badge } from 'react-bootstrap';
import '../../styles/status-badge.css';

interface BadgeApprovalProps {
  approvalStatus: boolean | null;
  className?: string;
}

const BadgeApprovalComponent = ({ approvalStatus, className }: BadgeApprovalProps) => {
  function getColorVariant(approvalStatus: boolean | null): string {
    if (approvalStatus === null) {
      return 'bg-primary'; // Blue for 'ΑΝΑΜΟΝΗ'
    }
    return approvalStatus ? 'bg-success' : 'bg-danger';
  }

  function getBadgeLabel(approvalStatus: boolean | null): string {
    if (approvalStatus === null) {
      return 'Αναμονή ';
    }
    return approvalStatus ? 'Εγκρίθηκε' : 'Απορρίφθηκε';
  }

  return (
    <div className={`${className} d-flex justify-content-center  w-full  `}>
      <Badge
        pill={true}
        className={`${getColorVariant(
          approvalStatus,
        )} badge-status align-middle pl-3 pr-3 text-white`}
      >
        {getBadgeLabel(approvalStatus)}
      </Badge>
    </div>
  );
};
export const BadgeApproval = memo(BadgeApprovalComponent);

